import React from "react";
import RadioButtonWithoutLabel from "../../common/RadioButton/RadioButtonWithoutLabel";

const CustomerItem = ({ id, name, value, label, selectedOption, onChange }) => {
  console.log(value, selectedOption);
  return (
    <label
      htmlFor={`${id}`}
      className="flex items-center w-full gap-4 p-4 rounded-[0.675rem]  mb-4
      bg-[#FAF8F8] hover:bg-[#e1dfdf] cursor-pointer
     transition-bg ease-in-out duration-100 drop-shadow-[0_4px_4px_rgba(16,16,16,0.1)]"
    >
      <label
        className="w-full cursor-pointer font-lato text-[1rem] font-normal"
        htmlFor={`${id}`}
      >
        {`${label}`}
      </label>
      {/* <input
        type="radio"
       
        className="w-5 cursor-pointer"
      /> */}
      <RadioButtonWithoutLabel
        name={`${name}`}
        id={`${id}`}
        value={value}
        onChange={onChange}
        selectedOption={selectedOption}
      />
    </label>
  );
};

export default CustomerItem;
